import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
const Page = lazy(() => import('@/features/agents/totals/page-client'))

export const Route = createFileRoute('/_authed/staff/agents/totals')({
  component: () => <Suspense fallback={null}><Page /></Suspense>,
})
